import { Close, ContentCopy, Visibility, VisibilityOff } from "@mui/icons-material";
import { Alert, Button, Dialog, DialogActions, DialogContent, Divider, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";

const IntegrationCredentials = ({ credentials, onClose }) => {
  if (!credentials) return null;

  function copyToClipboard(value, label) {
    try {
      navigator.clipboard.writeText(value);
      toast.success(`${label} copied`);
    } catch (error) {
      console.error("CLIPBOARD BODY:", error);
    }
  }

  return (
    <Dialog open={!!credentials} maxWidth="sm" PaperProps={{ className: "w-100", style: { maxWidth: 550 } }}>
      <div className="d-flex justify-content-between align-items-center gap-4 p-3 py-2 pe-2">
        <div className="fs-5 fw-medium">API Credentials</div>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <Divider className="bg-secondary-subtle" />
      <DialogContent>
        <Alert severity="warning" className="mb-4">
          The secret is shown once and cannot be retrieved later. Copy it now and share it with the customer securely.
        </Alert>

        <CredentialRow label="Integration ID" value={credentials?.integrationId} onCopy={copyToClipboard} />
        <CredentialRow label="Secret" value={credentials?.secret} onCopy={copyToClipboard} maskable />

        <div className="fs-xs text-secondary">
          Sent as the <span className="fw-medium">x-integration-id</span> and <span className="fw-medium">x-integration-secret</span> headers
          on every API call. The integration is active and ready to use.
        </div>
      </DialogContent>
      <DialogActions className="px-3 pb-3">
        <Button variant="contained" color="secondary" onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function CredentialRow({ label, value, onCopy, maskable }) {
  const [revealed, setRevealed] = useState(false);
  const masked = maskable && !revealed;

  return (
    <div className="mb-4">
      <div className="fs-sm text-secondary mb-1">{label}</div>
      <div className="input-group w-100">
        <div className="form-control text-break" style={{ fontFamily: "monospace" }}>
          {masked ? "•".repeat(value?.length || 0) : value}
        </div>
        {maskable && (
          <Tooltip title={revealed ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}>
            <Button variant="outlined" color="secondary" onClick={() => setRevealed((prev) => !prev)}>
              {revealed ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </Button>
          </Tooltip>
        )}
        <Button variant="outlined" color="secondary" onClick={() => onCopy(value, label)} startIcon={<ContentCopy fontSize="small" />}>
          Copy
        </Button>
      </div>
    </div>
  );
}

export default IntegrationCredentials;
